import { Colors, Language, Lightning, Router } from '@lightningjs/sdk'
import PagingGrid from '../components/grid/PagingGrid'
import { appSettings } from '../lib/AppSettings'
import GridCover from './coverItems/GridCover'
import ImageItemWrapper from '../lib/ui/helpers/ImageItemWrapper'

export default class CatchupPageWrapper extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      x: 1920,
      // BackDrop: {w: 1920, h: 1080, src: ''},
      // Shade: {w: 1920, h: 1080, rect: true, alpha: 0.15, color: 0xff343434},
      TitleWrapper: {
        x: 265,
        y: 257,
        Title: {
          w: 1450,
          h: 75,
          color: Colors('white').get(),
          text: {
            text: '',
            textAlign: 'left',
            fontSize: 55,
            shadow: true,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: 0x25000000,
            fontFace: 'OpenSansBold',
            lineHeight: 75,
          },
        },
        SubTitle: {
          w: 1450,
          h: 51,
          y: 88,
          color: Colors('white').get(),
          text: {
            text: Language.translate('CatchupSubTitle'),
            shadow: true,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: 0x25000000,
            textAlign: 'left',
            fontSize: 30,
            fontFace: 'OpenSansRegular',
            lineHeight: 35,
          },
        },
      },
      GridWrapper: {
        w: 1920,
        h: 690,
        x: 0,
        y: 420,
        clipping: true,
        CatchupGrid: {
          w: 1660,
          h: 600,
          x: 265,
          y: 20,
          type: PagingGrid,
          scrollOffsetStart: 20,
          scrollOffsetEnd: 200,
          spacing: 57,
          signals: { indexChanged: true, requestMoreItems: true },
        },
      },
    }
  }
  set gridMainIndex(v) {
    this._mainIndex = v
    this.tag('CatchupGrid')._navigate(this._mainIndex, 'down')
  }
  get gridMainIndex() {
    return this._mainIndex
  }
  set gridCrossIndex(v) {
    this._crossIndex = v
    this.tag('CatchupGrid')._navigate(this._crossIndex, 'right')
  }
  get gridCrossIndex() {
    return this._crossIndex
  }
  get gridIndex() {
    return this._index
  }
  set gridIndex(v) {
    this.tag('CatchupGrid').index = v
  }

  set pageData(data) {
    const { bg, pageTitle, menu, brandName } = data

    this._wrapper = data.wrapper.name
    this._items = data.items
    this._menuData = menu
    this._brandName = brandName
    this._liveVideo = data.liveVideo

    this.tag('CatchupGrid').reset()

    this.tag('CatchupGrid').patch({
      items: this._items.map(item => {
        return { w: 360, h: 400, type: ImageItemWrapper, itemType: GridCover, item, bgImage: bg }
      }),
      availableItems: this._items.length,
    })

    this.tag('Title').text = pageTitle
    this.signal('wrapperBuild', { wrapper: this._wrapper })
    // this.tag("BackDrop").texture = Img(bg).landscape(1920);
    // this.tag('BlurWpr').content = {w: 1920, h: 1080, texture: Img(bg).landscape(1920)};
  }

  set isActiveWrapper(bool) {
    this._isActiveWrapper = bool

    this.tag('CatchupGrid').isOnActiveWrapper = bool
  }

  clear() {
    this._cleared = true
  }

  _init() {
    this._cleared = false
    // this.tag('BackDrop').on('txLoaded', () => {
    // 	this.signal("wrapperBuild", {wrapper: this._wrapper});
    // });
    // this.tag('BackDrop').on('txError', () => {
    // 	this.signal("wrapperBuild", {wrapper: this._wrapper});
    // });
  }

  _focus() {
    this._setState('CatchupGrid')
  }
  _inactive() {
    this.stage.gc()
  }

  _unfocus() {
    this._setState('Idle')
  }

  static _states() {
    return [
      class Idle extends this {},

      class CatchupGrid extends this {
        $enter() {
          appSettings.catchUpBackState = {}
        }

        // _handleRight() {
        // 	if (this._liveVideo.status !== 'inactive') {
        // 		this._setState("VideoCover");
        // 	}
        // }

        _handleEnter() {
          // appSettings.catchUpBackState = this._menuData;
          Router.navigate(
            `episodes/catchUp/${this._brandName}/${this.tag('CatchupGrid').currentDataItem.id}`
          )
        }
        indexChanged({ index, mainIndex, crossIndex }) {
          this._mainIndex = mainIndex
          this._crossIndex = crossIndex
          this._index = index
        }

        _getFocused() {
          return this.tag('CatchupGrid')
        }
      },
    ]
  }
}
